import { useActive, useCommands } from '@remirror/react-core';
import CommandButton from '../CommandButton';
import React, { useCallback } from 'react';
import { ItalicOutlined } from '@ant-design/icons';

export const ItalicButton = React.memo(() => {
  const { toggleItalic } = useCommands();

  const handleSelect = useCallback(() => {
    if (toggleItalic.enabled()) {
      toggleItalic();
    }
  }, [toggleItalic]);

  const active = useActive().italic();
  const enabled = toggleItalic.enabled();

  return (
    <CommandButton
      aria-label={'Italic'}
      icon={<ItalicOutlined />}
      active={active}
      enabled={enabled}
      onClick={handleSelect}
    />
  );
});

export default ItalicButton;
